// Module
var code = "<p>Choose a theme for your questionnaire. Themes are professionally designed by designers that have focused on the look, feel and readability.</p> <p>Our pre-designed themes comes with different styles, visuals, fonts and colors, but you may always choose to customize them as you please.</p> ";
// Exports
module.exports = code;